import { Link } from "react-router-dom";
import { ArrowUpRight, Building2, GraduationCap, UserRound, Calculator, Terminal } from "lucide-react";
import { AreaLink } from "@/components/SiteNav";
import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/SectionHeader";

const PATHS = [
  {
    key: "aziende",
    tag: "Percorso A",
    title: "Per le Aziende",
    to: "/aziende",
    Icon: Building2,
    lead: "Accedi ai talenti di domani, prima di chiunque altro.",
    points: ["Ricezione di profili anonimi in target", "Matching basato su hard e soft skills", { text: "Calcola il tuo risparmio", Icon: Calculator }],
  },
  {
    key: "scuole",
    tag: "Percorso B",
    title: "Per gli Istituti",
    to: "/istituti",
    Icon: GraduationCap,
    lead: "Porta gli studenti dentro l'industria reale",
    points: ["Partecipazione a workshop operativi", "Uscite didattiche aziendali"],
  },
  {
    key: "candidati",
    tag: "Percorso C",
    title: "Per i Candidati",
    to: "/candidati",
    Icon: UserRound,
    lead: "Costruisci il tuo futuro, decodifica il tuo potenziale",
    points: ["CV moderno e gratuito", "Profilo attitudinale con AI", { text: "Prova il simulatore AI", Icon: Terminal }],
  },
];

const BivioCard = ({ tag, title, Icon, lead, points, k, to }) => (
  <article
    className="bivio-card glass group relative flex flex-col h-full rounded-[28px] p-8 sm:p-10 min-h-[400px] sm:min-h-[460px] overflow-hidden"
    data-testid={`bivio-card-${k}`}
  >
    <div className="flex items-start justify-between">
      <span className="h-14 w-14 rounded-2xl border border-[#1e2024] flex items-center justify-center bg-white/[0.02]">
        <Icon className="h-6 w-6 text-white" strokeWidth={1.5} />
      </span>
      <span className="bivio-arrow h-12 w-12 rounded-full border border-[#2a2d33] flex items-center justify-center text-titanium">
        <ArrowUpRight className="h-5 w-5" />
      </span>
    </div>
    <p className="mt-16 text-xs tracking-[0.3em] uppercase text-titanium">{tag}</p>
    <h3 className="mt-3 font-extrabold tracking-[-0.035em] text-3xl sm:text-4xl">
      <Link to={to} className="stretched-link" aria-label={`${title}: accedi al percorso dedicato`} data-testid={`bivio-link-${k}`}>
        {title}
      </Link>
    </h3>
    <p className="mt-4 text-titanium text-base leading-relaxed max-w-md">{lead}</p>
    <ul className="mt-8 space-y-3">
      {points.map((p) => (
        <li key={p.text || p} className="flex items-center gap-3 text-sm sm:text-base text-white/90">
          {p.Icon ? <p.Icon className="h-4 w-4 -ml-[5px] text-cyan" strokeWidth={1.75} /> : <span className="h-1.5 w-1.5 rounded-full bg-[#00e5ff] shadow-[0_0_8px_#00e5ff]" />}
          {p.text || p}
        </li>
      ))}
    </ul>
    <div className="mt-auto pt-10 flex flex-col items-start gap-5">
      <span className="bivio-access text-xs font-semibold tracking-[0.18em] uppercase text-titanium">Accedi al percorso dedicato</span>
      <AreaLink testId={`bivio-area-${k}`} className="relative z-10" />
    </div>
  </article>
);

export const Bivio = () => (
  <section id="bivio" className="relative py-20 lg:py-36 px-6" data-testid="bivio-section">
    <div className="max-w-7xl mx-auto">
      <SectionHeader
        index="01"
        eyebrow="Trivio Navigazionale"
        title="Tre percorsi. Un unico obiettivo."
        description="Scegli il tuo punto di accesso all'ecosistema Prodigy."
      />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {PATHS.map(({ key, ...p }, i) => (
          <Reveal key={key} delay={i * 150} className="h-full">
            <BivioCard {...p} k={key} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
